import { Route, Routes } from "react-router-dom";

import DynamicOffer from "./pages/DynamicOffer";
import { handleQueryStrings } from "./util/query";

const { showSavings, ppcid, cid } = handleQueryStrings();

export default function App() {
  return (
    <Routes>
      <Route
        path="*"
        element={
          <DynamicOffer ppcid={ppcid} cid={cid} showSavings={showSavings} />
        }
      />
    </Routes>
  );
}
